module.exports = __webpack_public_path__ + "static/media/首页自营楼层商品列表左.f120ba6e.png";